<template>
  <EyeMove />
</template>

<script>
import EyeMove from './uxExperience/eye-move.vue';
import _ from 'lodash';

export default {
  name: 'uxExperienceEyePanel',
  components: {
    EyeMove
  },
  props: {
    api: {
      type: String,
    },
    title: {
      type: String,
      default: 'UX体验管理-眼动测试'
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    
  },
  methods: {
  }
}
</script>

<style lang="less">
.ux-experience-panel {
  padding-bottom: 20px;
  &.data-panel {
    margin-top: 0;
  }
  .v-notice {
    color: #B7B7B7;
    padding-left: 4px;
  }
  .table-operator {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 8px 0 16px;
  }
  .g2-tooltip {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 3px;
    color: rgb(87, 87, 87);
    font-size: 12px;
    line-height: 20px;
    padding: 10px 10px 6px 10px;
  }
  .g2-tooltip-title {
    font-weight: bold;
    font-size: 14px;
  }
  .g2-tooltip-summary {
    border-bottom: 2px solid #8B7E74;
    font-weight: bold;
  }
  .g2-tooltip-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .multi-wrap {
    display: flex;
    justify-content: space-between;
  }
  .g2-tooltip-value {
    margin-left: 12px;
    // display: inline;
    float: right;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    max-width: 160px;
    overflow: hidden;
    // white-space: nowrap;
    text-overflow: ellipsis;
  }
  .ux-filter-title {
    margin-right: 12px;
    font-weight: bold;
  }
}

.ux-exp-tabs {
  padding-top: 20px;
  &.ant-tabs-card {
    .ant-tabs-content {
      margin-top: -16px;
      // .ant-tabs-tabpane {
      //   background: #fff;
      // }
    }
    .ant-tabs-bar {
      border-color: #fff;
      .ant-tabs-tab {
        border-color: transparent;
        background: transparent;
        font-size: 16px;
        font-weight: bold;
      }
      .ant-tabs-tab-active {
        border-color: #fff;
        background: #fff;
      }
    }
  }
}
</style>